import React from 'react';

export default function Contacto() {
  return (
    <div id='contacto'>
      <div className="hero bg-base-200 min-h-screen fade-in-on-scroll px-4 md:px-8 contacto-bg">
        <div className="container mx-auto py-8 md:py-16">
          <h1 className="text-3xl md:text-5xl font-bold text-center mb-8 md:mb-16 piel2">Contacto</h1>

          <div className="hero-content flex-col lg:flex-row-reverse gap-8 justify-center items-center max-w-6xl mx-auto">
            <div className="text-center w-full lg:w-1/2 flex justify-center items-center">
              <img
                src="img/13.webp"
                className="rounded-lg shadow-2xl w-full h-64 md:h-96 object-cover"
                alt="Contacto" />
            </div>

            <div style={{backgroundColor:'#FAFFFA'}} className="card bg-base-100 shadow-2xl w-full lg:w-1/2">
              <div className="text-center p-6">
                <h2 style={{color:'#3B4540'}} className="text-xl md:text-2xl font-bold">Escríbenos</h2>
                <hr className="solid separador my-4" />
                <div className='escribenos space-y-4'>
                  <div className="flex items-center justify-center gap-2">
                    <img className='img-c' src='img/11.png' />
                    <span className="text-sm md:text-base">Email: mauricio@iwie.space</span>
                  </div>
                  <div className="flex items-center justify-center gap-2">
                    <img className='img-c' src='img/10.png' />
                    <span className="text-sm md:text-base">Teléfono: +56 9 5810 8312</span>
                  </div>
                </div>
              </div>

              <form action="https://formsubmit.co/moises.s@iwie.ai" method="POST" className="card-body">
                <div className="form-control">
                  <span className="label">
                    <span className="label-text">Nombre</span>
                  </span>
                  <label className="input input-bordered flex items-center gap-2">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" className="h-4 w-4 opacity-70">
                      <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM12.735 14c.618 0 1.093-.561.872-1.139a6.002 6.002 0 0 0-11.215 0c-.22.578.254 1.139.872 1.139h9.47Z" />
                    </svg>
                    <input 
                      type="text" 
                      name="nombre"
                      className="grow" 
                      placeholder="Tu nombre" 
                      required
                    />
                  </label>
                </div>

                <div className="form-control">
                  <span className="label">
                    <span className="label-text">Teléfono</span>
                  </span>
                  <label className="input input-bordered flex items-center gap-2">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" className="h-4 w-4 opacity-70">
                      <path fillRule="evenodd" d="M1.885 1.885a2.5 2.5 0 0 1 3.54 0l1.325 1.325a2.5 2.5 0 0 1 0 3.54L6.285 7.215a.5.5 0 0 0-.06.636A11.996 11.996 0 0 0 8.15 9.776a11.996 11.996 0 0 0 1.925 1.925.5.5 0 0 0 .636-.06l.465-.465a2.5 2.5 0 0 1 3.54 0l1.325 1.325a2.5 2.5 0 0 1 0 3.54l-.465.465a2.5 2.5 0 0 1-2.717.54 13.954 13.954 0 0 1-6.213-4.088A13.954 13.954 0 0 1 2.5 6.745a2.5 2.5 0 0 1 .54-2.717l.465-.465Z" />
                    </svg>
                    <input 
                      type="phone" 
                      name="telefono"
                      className="grow" 
                      placeholder="Tu teléfono" 
                      required
                    />
                  </label>
                </div>

                <div className="form-control">
                  <span className="label">
                    <span className="label-text">Email</span>
                  </span>
                  <label className="input input-bordered flex items-center gap-2">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" className="h-4 w-4 opacity-70">
                      <path d="M2.5 3A1.5 1.5 0 0 0 1 4.5v.793c.026.009.051.02.076.032L7.674 8.51c.206.1.446.1.652 0l6.598-3.185A.755.755 0 0 1 15 5.293V4.5A1.5 1.5 0 0 0 13.5 3h-11Z" />
                      <path d="M15 6.954 8.978 9.86a2.25 2.25 0 0 1-1.956 0L1 6.954V11.5A1.5 1.5 0 0 0 2.5 13h11a1.5 1.5 0 0 0 1.5-1.5V6.954Z" />
                    </svg>
                    <input 
                      type="email" 
                      name="email"
                      className="grow" 
                      placeholder="ejemplo@email.com" 
                      required
                    />
                  </label>
                </div>

                <div className="form-control">
                  <span className="label">
                    <span className="label-text">Mensaje</span>
                  </span>
                  <textarea 
                    name="mensaje"
                    className="textarea textarea-bordered h-24" 
                    placeholder="Escribe tu mensaje aquí"
                    required
                  ></textarea>
                </div>

                <input type="hidden" name="_next" value="https://gei.cl/" />
                <input type="hidden" name="_captcha" value="false" />


                <div className="form-control mt-6">
                  <button type="submit" className="btn btn-primary">Enviar Mensaje</button>
                </div>

              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}